import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import themeInfo from "../../themes/themes";

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    marginRight: theme.spacing(3),
    fontSize: "1.1em",
    textDecoration: "none",
  },
}));

export default function Support() {
  const classes = useStyles();
  const theme = process.env.REACT_APP_THEME;

  const email = {
    to: themeInfo[theme].email,
    subject: "Question for support",
    body: "Are you running into an issue? We're here to help.",
  };

  return (
    <a
      className={classes.root}
      href={`mailto:${email.to}?subject=${email.subject.replace(
        " ",
        "%20"
      )}&body=${email.body.replace(" ", "%20")}`}
    >
      Got questions? Need help? Contact Berkeley Loans Support.
    </a>
  );
}
